import { get, post } from '@eika-infrastruktur/request';

import { AhvNotifikasjon, AhvOppfolgingDTO } from '../generated-types';
import { CONTEXT_PATH } from './index';

export const SERVICE_PATH = `/rest/resource/ahvoppdrag`;

export const getAntiMoneyLaunderingAssignments = async () =>
    get<AhvOppfolgingDTO[]>(`${CONTEXT_PATH}${SERVICE_PATH}/hent`);

export const sendAntiMoneyLaunderingAssignmentsNotification = async (customerId: string) =>
    post<AhvNotifikasjon>(`${CONTEXT_PATH}${SERVICE_PATH}/notifikasjon`, { kundeId: customerId });
